import {isEmpty} from 'lodash-es';
import type {ReactElement} from 'react';
import {useState} from 'react';

import {Button} from '@/components';
import type {AfriexFeature} from '@/types';

import FeatureFormModal from './FeatureFormModal';

type FeatureUpdateButtonProps = {
  initialData?: AfriexFeature;
  dataCy?: string;
};

const FeatureUpdateButton = ({
  initialData,
  dataCy,
}: FeatureUpdateButtonProps): ReactElement => {
  const [showFullScreen, setShowFullScreen] = useState(false);
  const updateLabel = isEmpty(initialData)
    ? 'Create Feature +'
    : 'Update Feature';
  const toggleFullScreen = () => {
    setShowFullScreen(!showFullScreen);
  };

  return showFullScreen ? (
    <FeatureFormModal
      isOpen={showFullScreen}
      onClose={toggleFullScreen}
      initialData={initialData}
    />
  ) : (
    <Button
      variant="solid"
      colorScheme="cyan"
      onClick={toggleFullScreen}
      dataCy={dataCy}
    >
      {updateLabel}
    </Button>
  );
};

export default FeatureUpdateButton;
